export const QUERY_PAYMENT_CARDS = "QUERY_PAYMENT_CARDS";
export const QUERY_PAYMENT_CARD = "QUERY_PAYMENT_CARD";
